module.exports = __webpack_public_path__ + "static/media/deletewhite.1a0f854c.svg";